module.exports = __webpack_public_path__ + "img/img-hospital-plan.04471edf.png";